import Highlighter from "react-highlight-words"
import styles from "./HighLightText.module.scss"
import translate from "src/common/translations"

const HighlightText = ({ name, searchText, translateLabel = false }) => {
  const translateName = translate(name)
  return (
    <Highlighter
      highlightClassName={styles.searchHighlight}
      searchWords={[searchText]}
      autoEscape={true}
      textToHighlight={translateLabel ? translateName : name}
    />
  )
}

export default HighlightText
